import { Component } from 'vue';
import { FieldComponentParams, FieldComponent, FieldComponentClass } from '@/types/FieldComponent';
import { GraphQLField } from 'graphql';
import TypeInspector from '@/classes/graphql-introspection/TypeInspector';
import PreviewDefaultField from '@/components/FormBuilder/preview/PreviewDefaultField.vue';

export default abstract class FieldComponentFactory implements FieldComponentClass {
  abstract component: Component;

  previewComponent: Component = PreviewDefaultField;

  typeInspector = TypeInspector;

  abstract support(field: GraphQLField<any, any, any>): boolean;

  /**
   * Преобразование значение для хранения в pimcore
   * @param value
   */
  async normalizeBeforeSave(value: any): Promise<any> {
    return value;
  }

  /**
   * Преобразование значение из pimcore для последующего редактирования
   * @param value
   */
  async normalizeBeforeEdit(value: any): Promise<any> {
    return value;
  }

  async createComponent(params: FieldComponentParams): Promise<FieldComponent> {
    const {
      name, value, attrs = {}, props = {}, validationRules = [],
    } = params;
    const beforeSave = this.normalizeBeforeSave || null;
    const preparedValue = await this.normalizeBeforeEdit(value);

    return {
      component: this.component,
      previewComponent: this.previewComponent,
      name,
      value: preparedValue,
      attrs,
      props,
      validationRules,
      beforeSave,
    };
  }
}
